import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eDmTrangThaiHocActionIds } from "../../action-types/category/IDmTrangThaiHocActions";
import { rootActions } from "../../actions/rootActions";
import { trangThaiHocApi } from "../../../api/category/trangThaiHocApi";

export function* trangThaiHocSaga(): any {
  yield takeLatest(eDmTrangThaiHocActionIds.LOAD_START, loadWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(trangThaiHocApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.trangThaiHoc.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.trangThaiHoc.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}
